import { Fun, loadedAsyncState } from 'widgets-for-react'
import {
  ComponentTeaserData,
  ComponentTeasersState,
} from '../../components/componentTeasers/componentTeasersState'
import {
  CollectionDeleterState,
  collectionDeleterStateUpdaters,
  initialCollectionDeleterState,
} from '../collectionDeleter/collectionDeleterState'
import {
  CollectionEditorState,
  collectionEditorStateUpdaters,
  initialCollectionEditorState,
} from '../collectionEditor/collectionEditorState'

export type CollectionDetailState = {
  collectionDeleterState: CollectionDeleterState
  collectionEditorState: CollectionEditorState
  componentDeleterState: CollectionDeleterState
}

export const initialCollectionDetailState: CollectionDetailState = {
  collectionDeleterState: initialCollectionDeleterState,
  collectionEditorState: initialCollectionEditorState,
  componentDeleterState: initialCollectionDeleterState,
}

export const collectionDetailStateUpdater = {
  startDeletingCollectionUpdater: (
    state: CollectionDetailState
  ): CollectionDetailState => ({
    ...state,
    collectionDeleterState:
      collectionDeleterStateUpdaters.startDeletingUpdater()(
        state.collectionDeleterState
      ),
  }),
  collectionDeleterUpdater:
    (
      update: Fun<
        CollectionDeleterState,
        CollectionDeleterState & { reloadCollections: boolean }
      >
    ) =>
    (
      state: CollectionDetailState
    ): CollectionDetailState & { reloadCollections: boolean } => {
      const newState = update(state.collectionDeleterState)
      return {
        ...state,
        collectionDeleterState: newState,
        reloadCollections: newState.reloadCollections,
      }
    },
  startEditingUpdater:
    (name: string, description: string) =>
    (state: CollectionDetailState): CollectionDetailState => ({
      ...state,
      collectionEditorState: collectionEditorStateUpdaters.startEditingUpdater(
        name,
        description
      )(state.collectionEditorState),
    }),
  collectionEditorUpdater:
    (
      update: Fun<
        CollectionEditorState,
        CollectionEditorState & { reloadCollections?: boolean }
      >
    ) =>
    (
      state: CollectionDetailState
    ): CollectionDetailState & { reloadCollections?: boolean } => {
      const newState = update(state.collectionEditorState)
      return {
        ...state,
        collectionEditorState: newState,
        reloadCollections: newState.reloadCollections,
      }
    },
  startDeletingComponentUpdater:
    (components: ComponentTeaserData[]) =>
    (
      update: Fun<
        ComponentTeasersState,
        ComponentTeasersState & { saveComponentId: number | 'none' }
      >
    ) =>
    (state: CollectionDetailState): CollectionDetailState => {
      const deletingComponent = update(
        loadedAsyncState(
          components.map((component) => ({
            ...component,
            Image: component.ImageURL,
          }))
        )
      ).saveComponentId
      return {
        ...state,
        componentDeleterState:
          deletingComponent == 'none'
            ? state.componentDeleterState
            : collectionDeleterStateUpdaters.startDeletingUpdater(
                deletingComponent
              )(state.componentDeleterState),
      }
    },
  componentDeleterUpdater:
    (
      update: Fun<
        CollectionDeleterState,
        CollectionDeleterState & { reloadCollections: boolean }
      >
    ) =>
    (
      state: CollectionDetailState
    ): CollectionDetailState & { reloadCollections: boolean } => {
      const newState = update(state.componentDeleterState)
      return {
        ...state,
        componentDeleterState: newState,
        reloadCollections: newState.reloadCollections,
      }
    },
}
